import { wencesApi } from "@/api/wencesApi";
import { isAxiosError } from "axios";


export const getIndividuals = async () => {
  try {
    const { data } = await wencesApi.get(`/api/users/individual-gym-users`);

    return data;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 401) {
      return {
        ok: false,
        message: "Menu no existe",
      };
    }

    console.log(error);
    throw new Error("No se pudo realizar la petición");
  }
};
